<div class="card h-100">
  <div class="card-body d-flex p-2">
    <div class="d-flex flex-column w-100 h-100">
      <!-- Image -->
      <div class="card-rounded position-relative">
        @if (data.blog_img) {
        <img
          class="object-position-top bgi-no-repeat bgi-size-cover h-200px w-100 object-fit-cover card-rounded"
          [src]="data.blog_img"
          [attr.alt]="data.name"
        />
        } @else {
        <!-- Articles carry no cover, and the shared placeholder is a grey
             broken-image glyph — four of them side by side read as a page that
             failed to load rather than as a list of articles. A tinted panel
             with the section's own art says "this post has no photograph",
             which is true, and looks deliberate. -->
        <div class="blog-cover h-200px w-100 card-rounded" [ngClass]="coverTint()">
          <img class="blog-cover__art" [src]="coverArt()" alt="" />
        </div>
        }
        <!-- <button
          class="btn btn-icon h-auto w-auto p-0 ms-n10 mb-2 position-absolute bottom-0 right-0"
        >
          <app-keenicon name="to-right" class="fs-2x text-white"></app-keenicon>
        </button> -->
      </div>
      <!-- <div class="col-sm-12 mb-0 cursor-pointer">
        <img
          [src]="
            data.blog_img
              ? data.blog_img
              : './assets/media/svg/files/blank-image.svg'
          "
          class="mh-200px col-12 h-200px rounded bg-light object-fit-cover"
          [attr.alt]="data.name"
        />
      </div> -->
      <!-------->
      <div
        class="col-sm-12 d-flex flex-row justify-content-between align-items-center flex-grow-1 pt-5 px-2 pb-3"
      >
        <div class="col-12">
          <div>
            <!-- Two lines, not one. Every title on this page is a sentence and
                 the one-line clamp cut all four of them mid-word, so the grid
                 read as four articles nobody could name. `lh-1` was part of the
                 same problem: at a single line it looks tight, at two the
                 descenders collide. -->
            <p
              class="blog-title text-gray-800 text-hover-primary fs-6 fw-semibold mb-2 cursor-pointer text-overflow-line-2"
            >
              {{ data.name }}
            </p>
            @if (data.blog_category_name) {
            <span class="blog-chip">{{ data.blog_category_name }}</span>
            }
            <p class="text-gray-600 text-overflow-line-1 fs-7 mb-0">
              {{ "APP.PUBLIC" | translate }}:
              {{ data.is_today ? "วันนี้" : (data.created_at | customDate) }}
            </p>
          </div>
        </div>

        <!-- <div #button_group class="col-4 d-flex flex-end">
          <button
            class="btn btn-sm btn-icon btn-outline btn-outline-primary rounded-pill fw-semibold"
          >
            <app-keenicon name="eye" class="svg svg-icon fs-1"></app-keenicon>
          </button>
        </div> -->
      </div>
    </div>
  </div>
</div>
